import { Box, CircularProgress } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { useAuth } from "./auth/AuthContext";
import { LoginPage } from "./auth/LoginPage";
import { BudgetEditorPage } from "./pages/BudgetEditorPage";
import { CostDetailPage } from "./pages/CostDetailPage";
import { ContractsPage } from "./pages/ContractsPage";
import { CostsPage } from "./pages/CostsPage";
import { CrewPage } from "./pages/CrewPage";
import { PeoplePage } from "./pages/PeoplePage";
import { PersonPage } from "./pages/PersonPage";
import { ProjectPage } from "./pages/ProjectPage";
import { PortfolioPage } from "./pages/PortfolioPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ReportPage } from "./pages/ReportPage";
import { ScansPage } from "./pages/ScansPage";
import { TemplatesPage } from "./pages/TemplatesPage";

export function App() {
  const { me, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!me) return <LoginPage />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/portfel" element={<PortfolioPage />} />
        <Route path="/projekty" element={<ProjectsPage />} />
        <Route path="/projekty/:code" element={<ProjectPage />} />
        <Route path="/projekty/:code/kosztorys/:id" element={<BudgetEditorPage />} />
        <Route path="/wykonawcy" element={<PeoplePage />} />
        <Route path="/wykonawcy/:id" element={<PersonPage />} />
        <Route path="/projekty/:code/obsada" element={<CrewPage />} />
        <Route path="/projekty/:code/koszty" element={<CostsPage />} />
        <Route path="/projekty/:code/koszty/:id" element={<CostDetailPage />} />
        <Route path="/projekty/:code/umowy" element={<ContractsPage />} />
        <Route path="/projekty/:code/skany" element={<ScansPage />} />
        <Route path="/projekty/:code/raport" element={<ReportPage />} />
        <Route path="/szablony" element={<TemplatesPage />} />
        <Route path="*" element={<Navigate to="/projekty" replace />} />
      </Route>
    </Routes>
  );
}
